import { Link } from "react-router-dom";
import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

// KEEP OLD PROJECT IMAGES (UNCHANGED)
// Crypto Exchange Services
import ExchangeDevelopment from "../../images/serviceSection/Crypto Exchange Services/Exchange Development.png";
import CryptoExchangeDevelopment from "../../images/serviceSection/Crypto Exchange Services/Centralized Crypto Exchange.png";


// Crypto & Token Services
import TokenDevelopment from "../../images/serviceSection/Crypto & Token Services/Token Development.png";
import ICODevelopment from "../../images/serviceSection/Crypto & Token Services/ICO Development.png";

// Web 3.0
import NFTMarketplaces from "../../images/serviceSection/Web 3.0/NFT Marketplaces.png";

// Blockchain Services
import SmartContract from "../../images/serviceSection/Blockchain Services/Smart Contract Audit.png";

import DAppImg from "../../images/serviceSection/servicesCrypto Development Suite/dApp.png";
import DigitalMarketingImg from "../../images/serviceSection/servicesCrypto Development Suite/Digital Marketing.png";


// SAME ARROW ICON (UNCHANGED)
const ArrowIcon = () => (
  <>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>

    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>
  </>
);

// 🔑 MEGAMENU-7 → PAGE DATA
const megaProjects = [
  {
    title: "Crypto Solutions",
    content:
      "Complete crypto ecosystem development including exchanges, wallets, tokens, and enterprise-grade blockchain infrastructure.",
    link: "/crypto-exchange-service",
    images: [CryptoExchangeDevelopment, CryptoExchangeDevelopment, CryptoExchangeDevelopment, CryptoExchangeDevelopment],
    reverse: false,
  },
  {
    title: "Exchange Development",
    content:
      "Secure and scalable crypto exchange development with advanced trading features and liquidity integration.",
    link: "/exchange-development",
    images: [ExchangeDevelopment, ExchangeDevelopment, ExchangeDevelopment, ExchangeDevelopment],
    reverse: true,
  },
  {
    title: "Token Development",
    content:
      "Custom token development services for ERC, BEP, and multi-chain standards with secure smart contracts.",
    link: "/token-development",
    images: [TokenDevelopment, TokenDevelopment, TokenDevelopment, TokenDevelopment],
    reverse: false,
  },
  {
    title: "NFT Marketplace",
    content:
      "NFT marketplace development with minting, auctions, royalties, wallet integration, and custom UI.",
    link: "/nft-marketplace-service",
    images: [NFTMarketplaces, NFTMarketplaces, NFTMarketplaces, NFTMarketplaces],
    reverse: true,
  },
  {
    title: "Smart Contract Development",
    content:
      "Robust and audited smart contract development for DeFi, NFTs, DAOs, and enterprise use cases.",
    link: "/smart-contract-development",
    images: [SmartContract, SmartContract, SmartContract, SmartContract],
    reverse: false,
  },
  {
    title: "DApp Development",
    content:
      "Decentralized application development with Web3 integrations, smart contracts, and scalable architectures.",
    link: "/dapp-development",
    images: [DAppImg, DAppImg, DAppImg, DAppImg],
    reverse: true,
  },
  {
    title: "ICO Services",
    content:
      "End-to-end ICO services including token creation, launch strategy, compliance, and marketing support.",
    link: "/ico",
    images: [ICODevelopment, ICODevelopment, ICODevelopment, ICODevelopment],
    reverse: false,
  },
  {
    title: "Digital Marketing",
    content:
      "Crypto-focused digital marketing services to build communities, boost visibility, and drive adoption.",
    link: "/digital-marketing",
    images: [DigitalMarketingImg, DigitalMarketingImg, DigitalMarketingImg, DigitalMarketingImg],
    reverse: true,
  },
];

const CryptoDevelopmentSuitePage: React.FC = () => {
  return (
    <Fragment>
      <div className="service-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle
              pageTitle="Crypto Development Suite"
              pagesub="Blockchain, Tokens, NFTs & Growth Solutions"
            />

            <section className="service pos-rel">
              <div className="container mxw-1650">
                <div className="xb-project-wrap xb-project-wrap_2">

                  {megaProjects.map((item, index) => (
                    <div className="xb-project-item" key={index}>

                      {!item.reverse ? (
                        <>
                          <div className="xb-project-content">
                            <div className="xb-item--inner xb-border">
                              <h2 className="xb-item--title">{item.title}</h2>
                              <p className="xb-item--content clr-white">{item.content}</p>

                              <div className="xb-item--btn mt-40">
                                <Link className="thm-btn agency-btn" to={item.link}>
                                  <span className="text">Explore</span>
                                  <span className="arrow">
                                    <span className="arrow-icon"><ArrowIcon /></span>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>

                          <div className="xb-project-img img-hove-effect">
                            <div className="xb-img">
                              {item.images.map((img, i) => (
                                <Link to={item.link} key={i}>
                                  <img src={img} alt="service" />
                                </Link>
                              ))}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="xb-project-img img-hove-effect">
                            <div className="xb-img">
                              {item.images.map((img, i) => (
                                <Link to={item.link} key={i}>
                                  <img src={img} alt="service" />
                                </Link>
                              ))}
                            </div>
                          </div>

                          <div className="xb-project-content">
                            <div className="xb-item--inner xb-border">
                              <h2 className="xb-item--title">{item.title}</h2>
                              <p className="xb-item--content clr-white">{item.content}</p>

                              <div className="xb-item--btn mt-40">
                                <Link className="thm-btn agency-btn" to={item.link}>
                                  <span className="text">Explore</span>
                                  <span className="arrow">
                                    <span className="arrow-icon"><ArrowIcon /></span>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                    </div>
                  ))}

                </div>
              </div>
            </section>

          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default CryptoDevelopmentSuitePage;
